<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />
            
            <br />
            <div style="display: flex" class="mb-5">
              <!-- <CCard class="custom-card-advertise" v-for="(item, index) in news.slice(0, 3)"
                  v-bind:key="item.Id"
                  sm="3">
                <a :href="GoToLink(index)">
                    <div>
                      <img
                        class="custom-bg-advetise"
                        :src="getPic(index)"
                      />
                    </div>
                  </a>
              </CCard> -->
              <CCol sm="12" class="mt-2 mb-3">
                <CRow>
                  <CCol
                    v-for="(item, index) in news"
                    v-bind:key="item.Id"
                    sm="6"
                  >
                    <a :href="GoToLink(index)">
                      <div class="text-center p-1">
                        <img
                          style="max-width: 100%; border-radius: 10px"
                          :src="getPic(index)"
                        />
                      </div>
                    </a>
                  </CCol>
                </CRow>
              </CCol>
            </div>

            <!-- <CCard class="custom-bg-color mt-3 d-sm-down-none" @click="GoToRegStud()">
              <CRow>
                <div style="width: 60%" class="float-left">
                  <h3
                    style="text-align: left; margin: 20px 30px"
                    class="sub-title-header"
                  >
                    I’m a student<br />
                    and want to register <br />
                    for myself<br />
                  </h3>
                </div>
                <div style="width: 20%" class="float-right">
                  <img  style="
                      max-width: 100%;
                      right: 0;
                      position: absolute;
                      bottom: 0;
                    "
                     src="../assets/img/icon/vectorstudent.svg" />
                </div>
              </CRow>
            </CCard>




            <CCard class="custom-bg-color d-flex d-md-none" @click="GoToRegStudParent()">
              <CRow>
                <div style="width: 60%" class="float-left">
                  <h3
                    style="text-align: left; margin: 20px 30px"
                    class="sub-title-header"
                  >
                    I’m a Parents <br />
                    and want to register <br />
                    for my kids
                  </h3>
                </div>
                <div style="width: 20%" class="float-right">
                  <img src="../assets/img/icon/Parents-bro1.svg" />
                </div>
                <div style="clear:both"></div>
              </CRow>
            </CCard>

            <CCard class="custom-bg-color mt-3 d-flex d-md-none" @click="GoToRegStud()">
              <CRow>
                <div style="width: 60%" class="float-left">
                  <h3
                    style="text-align: left; margin: 20px 30px"
                    class="sub-title-header"
                  >
                    I’m a student<br />
                    and want to register <br />
                    for myself<br />
                  </h3>
                </div>
                <div style="width: 20%" class="float-right">
                  <img src="../assets/img/icon/vectorstudent.svg" />
                </div>
              </CRow>
            </CCard> -->
          </div>
        </div>
      </div>
    </CContainer>
    <div class="header-top">Hot Pick</div>
    <div class="header-left">
      <img src="../assets/img/icon/VectorLeft.svg" @click="GoBack()"/>
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
export default {
    data: function () {
    return {
      news: [],
    };
  },
    async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetNews();
          }
        });
    },
    GoBack() {
      this.$router.back();
    },
    GetNews() {
      this.$API.get(this.$ListNews +
            "?start=0&limit=10", {}).then((response) => {
        if (response.status == 200 && response.data != null) {
          this.news = response.data;
          this.getPic(this.news.urlImage);
          this.GoToLink(this.news.Url);
        }
      });
    },
    getPic(index) {
      return this.news[index].urlImage;
    },
    GoToLink(index) {
      return this.news[index].url;
    },
  }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}

.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: auto;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}

body {
  font-family: "Montserrat", sans-serif;
}

</style>